export class ExperimentGroup {
    constructor(id, name, type) {
        this.id = id;
        this.name = name;
        this.type = type;
    }
}
//# sourceMappingURL=ExperimentGroup.js.map